import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

const tableHeaderMessages = defineMessages({
  active: { id: "app.active", defaultMessage: "Active" },
  ticker: { id: "insurance.tableHeader.id", defaultMessage: "ID" },
  title: { id: "insurance.tableHeader.name", defaultMessage: "Name" },
  typology: { id: "insurance.tableHeader.type", defaultMessage: "Type" },
  validFrom: { id: "insurance.tableHeader.validFrom", defaultMessage: "Valid From" },
  validTo: { id: "insurance.tableHeader.validTo", defaultMessage: "Valid To" },
});

export const messages = {
  ...defaultCrudMessages,
  tableHeaders: tableHeaderMessages,
  entityName: {
    id: "insurances.entityName",
    defaultMessage: "Insurances",
  },
  delete: {
    id: "app.entityList.tooltip.delete",
    description: "Delete message",
    defaultMessage: "Delete",
  },
  view: {
    id: "app.entityList.tooltip.view",
    description: "view",
    defaultMessage: "view",
  },
  edit: {
    id: "app.entityList.tooltip.edit",
    description: "edit",
    defaultMessage: "edit",
  },
  drag: {
    id: "app.entityList.tooltip.reorder",
    description: "Reorder message",
    defaultMessage: "Reorder",
  },
  duplicate: {
    id: "app.entityList.tooltip.duplicate",
    description: "Duplicate message",
    defaultMessage: "Duplicate",
  },
  percentage: {
    id: "insurance.percentage",
    defaultMessage: "Percentage",
  },
  amount: {
    id: "insurance.amount",
    defaultMessage: "Amount",
  },
  with_tax: {
    id: "insurance.taxBase.withTax",
    defaultMessage: "With Tax",
  },
  without_tax: {
    id: "insurance.taxBase.withoutTax",
    defaultMessage: "Without Tax",
  },
};
